import React from 'react';
import { useCurrentRoute, useNavigation } from 'react-navi';
import { Hero, NewsSection } from '@contest-web/components/src/sections';
import { NewsItem } from '@contest-web/components/src/elements';
import { EntryCard, LegendVoice, EntriesNavBar } from '@contest-web/components/src/components';
import { AboutSection } from '../components/sections/About';

function IndexApp() {
  let route = useCurrentRoute();
  let navigation = useNavigation();
  return (
    <>
      <Hero
        finished
        logoImageSrc="/images/logo_white.svg"
        entryUrl={`${process.env.REACT_APP_ENTRY_FORM_URL}${route.url.search}`}
      >
        <h1 className="title is-stripe is-primary is-spaced is-size-4-mobile" style={{ marginBottom: '1rem' }}>
          <span className="is-letter-spacing-2px">
            日本一のサークル美人を
            <br className="is-hidden-tablet" />
            決めるコンテスト
          </span>
        </h1>
        <a
          className="button is-size-6 is-hero is-inverted is-outlined is-primary is-medium has-text-weight-bold"
          href="#award"
        >
          <span className="icon is-small">
            <i className="fas fa-caret-square-down" />
          </span>
          <span>グランプリがついに決定!!</span>
        </a>
      </Hero>

      {/* ↓ 結果発表　*/}

      <section id="award" className="section has-background-gold-stripe">
        <div className="container has-text-centered">
          <h1 className="title is-margin-bottom-4 ">
            <span className="is-family-secondary has-text-gold">AWARD</span>
            受賞者一覧
          </h1>
          {/* 受賞者一覧 */}
          {/* グランプリ x1 */}
          <div className=" is-margin-bottom-4">
            <h1 className="is-size-3 has-text-weight-bold is-margin-bottom-2">グランプリ</h1>
            <div className="columns is-centered is-mobile">
              <div className="column is-full" style={{ maxWidth: 400 }}>
                <EntryCard
                  onClick={async () => {
                    navigation.navigate(`/profile/${8}`);
                  }}
                  lazy
                  entryNumber={8}
                  name={'黒川さくら'}
                  college={'青山学院大学'}
                  twitter={'mscircle19_008'}
                  instagram={'misscirclesakura'}
                  circle={'青山学院大学アナウンス研究会'}
                />
              </div>
            </div>
          </div>
          {/* 準グランプリ x 2 */}
          <div className=" is-margin-bottom-4">
            <h1 className="is-size-4 is-margin-bottom-2 has-text-weight-bold">準グランプリ</h1>
            <div className="columns is-mobile is-centered">
              <div className="column is-half" style={{ maxWidth: 320 }}>
                <EntryCard
                  onClick={async () => {
                    navigation.navigate(`/profile/${87}`);
                  }}
                  lazy
                  entryNumber={87}
                  name={'町遥香'}
                  college={'学習院大学'}
                  twitter={'mscircle19_087'}
                  instagram={'cq_haruka_m'}
                  circle={'学習院大学 doscoy'}
                />
              </div>
              <div className="column is-half" style={{ maxWidth: 320 }}>
                <EntryCard
                  onClick={async () => {
                    navigation.navigate(`/profile/${112}`);
                  }}
                  lazy
                  entryNumber={112}
                  name={'斎藤渚'}
                  college={'中央大学'}
                  twitter={'mscircle19_112'}
                  instagram={'nagi3_0516'}
                  circle={'中央大学 劇団The座'}
                />
              </div>
            </div>
          </div>
          {/* 審査員特別賞 x 3 */}
          <div className=" is-margin-bottom-4">
            <h1 className="is-size-4 is-margin-bottom-2 has-text-weight-bold">審査員特別賞</h1>
            <div className="columns is-mobile is-centered is-multiline">
              <div className="column is-half" style={{ maxWidth: 240 }}>
                <EntryCard
                  onClick={async () => {
                    navigation.navigate(`/profile/${83}`);
                  }}
                  lazy
                  entryNumber={83}
                  name={'宮澤咲希'}
                  college={'京都女子大学'}
                  twitter={'mscircle19_083'}
                  instagram={'mscircle19_083'}
                  circle={'京大アトランティス'}
                />
              </div>
              <div className="column is-half" style={{ maxWidth: 240 }}>
                <EntryCard
                  onClick={async () => {
                    navigation.navigate(`/profile/${166}`);
                  }}
                  lazy
                  entryNumber={166}
                  name={'水野愛友美'}
                  college={'金城学院大学'}
                  twitter={'mscircle19_166'}
                  instagram={'amym0727'}
                  circle={'アナウンス同好会'}
                />
              </div>
              <div className="column is-half" style={{ maxWidth: 240 }}>
                <EntryCard
                  onClick={async () => {
                    navigation.navigate(`/profile/${238}`);
                  }}
                  lazy
                  entryNumber={238}
                  name={'井手麻以花'}
                  college={'青山学院大学'}
                  twitter={'mscircle19_238'}
                  instagram={'maika_i48'}
                  circle={'手話部'}
                />
              </div>
            </div>
          </div>
          {/*
            リゼウォーク賞 x 1
            リゼクリニック賞 x 1
          */}
          <div className=" is-margin-bottom-4">
            <div className="columns is-mobile is-centered is-multiline">
              <div className="column is-half" style={{ maxWidth: 240 }}>
                <h1 className="is-size-5 is-size-6-mobile is-margin-bottom-2 has-text-weight-bold">リゼクリニック賞</h1>
                <EntryCard
                    onClick={async () => {
                      navigation.navigate(`/profile/${87}`);
                    }}
                    lazy
                    entryNumber={87}
                    name={'町遥香'}
                    college={'学習院大学'}
                    twitter={'mscircle19_087'}
                    instagram={'cq_haruka_m'}
                    circle={'学習院大学 doscoy'}
                />
              </div>
              <div className="column is-half" style={{ maxWidth: 240 }}>
                <h1 className="is-size-5 is-size-6-mobile is-margin-bottom-2 has-text-weight-bold">リゼウォーク賞</h1>
                <EntryCard
                  onClick={async () => {
                    navigation.navigate(`/profile/${112}`);
                  }}
                  lazy
                  entryNumber={112}
                  name={'斎藤渚'}
                  college={'中央大学'}
                  twitter={'mscircle19_112'}
                  instagram={'nagi3_0516'}
                  circle={'中央大学 劇団The座'}
                />
              </div>

            </div>
          </div>
          {/*
            フジテレビアナトレ賞 x 1
            モデルプレス賞 x 1
            DHC賞 x 1
           */}
          <div className="is-margin-bottom-4">
            <div className="columns is-mobile is-centered is-multiline">
              <div className="column is-half" style={{ maxWidth: 240 }}>
                <h1 className="is-size-5 is-size-6-mobile is-margin-bottom-2 has-text-weight-bold">アナトレ賞</h1>
                <EntryCard
                  onClick={async () => {
                    navigation.navigate(`/profile/${238}`);
                  }}
                  lazy
                  entryNumber={238}
                  name={'井手麻以花'}
                  college={'青山学院大学'}
                  twitter={'mscircle19_238'}
                  instagram={'maika_i48'}
                  circle={'手話部'}
                />
              </div>
              <div className="column is-half" style={{ maxWidth: 240 }}>
                <h1 className="is-size-5 is-size-6-mobile is-margin-bottom-2 has-text-weight-bold">DHC賞</h1>
                <EntryCard
                    onClick={async () => {
                      navigation.navigate(`/profile/${177}`);
                    }}
                    lazy
                    entryNumber={177}
                    name={'藤野亜紗美'}
                    college={'慶應義塾大学'}
                    twitter={'mscircle19_177'}
                    instagram={'asami_fujino_177'}
                    circle={'慶應義塾大学アルメリアローンテニスクラブ'}
                />
              </div>
              <div className="column is-half" style={{ maxWidth: 240 }}>
                <h1 className="is-size-5 is-size-6-mobile is-margin-bottom-2 has-text-weight-bold">モデルプレス賞</h1>
                <EntryCard
                  onClick={async () => {
                    navigation.navigate(`/profile/${8}`);
                  }}
                  lazy
                  entryNumber={8}
                  name={'黒川さくら'}
                  college={'青山学院大学'}
                  twitter={'mscircle19_008'}
                  instagram={'misscirclesakura'}
                  circle={'青山学院大学アナウンス研究会'}
                />
              </div>
            </div>
          </div>
          {/*
            mysta賞 x 1
            SHOWROOM賞 x 1
          */}
          <div className=" is-margin-bottom-4">
            <div className="columns is-mobile is-centered is-multiline">
              <div className="column is-half" style={{ maxWidth: 240 }}>
                <h1 className="is-size-5 is-size-6-mobile is-margin-bottom-2 has-text-weight-bold">mysta賞</h1>
                <EntryCard
                  onClick={async () => {
                    navigation.navigate(`/profile/${87}`);
                  }}
                  lazy
                  entryNumber={87}
                  name={'町遥香'}
                  college={'学習院大学'}
                  twitter={'mscircle19_087'}
                  instagram={'cq_haruka_m'}
                  circle={'学習院大学 doscoy'}
                />
              </div>
              <div className="column is-half" style={{ maxWidth: 240 }}>
                <h1 className="is-size-5 is-size-6-mobile is-margin-bottom-2 has-text-weight-bold">SHOWROOM賞</h1>
                <EntryCard
                  onClick={async () => {
                    navigation.navigate(`/profile/${238}`);
                  }}
                  lazy
                  entryNumber={238}
                  name={'井手麻以花'}
                  college={'青山学院大学'}
                  twitter={'mscircle19_238'}
                  instagram={'maika_i48'}
                  circle={'手話部'}
                />
              </div>
            </div>
          </div>
          {/* ミスコレ賞 x 1 */}
          <div className=" is-margin-bottom-4">
            <div className="columns is-mobile is-centered is-multiline">
              <div className="column is-half" style={{ maxWidth: 240 }}>
                <h1 className="is-size-5 is-size-6-mobile is-margin-bottom-2 has-text-weight-bold">ミスコレ賞</h1>
                <EntryCard
                  onClick={async () => {
                    navigation.navigate(`/profile/${193}`);
                  }}
                  lazy
                  entryNumber={193}
                  name={'石黒香奈'}
                  college={'金城学院大学'}
                  twitter={'mscircle19_193'}
                  instagram={'kana_lavi'}
                  circle={'チア＆バトンサークル 金城学院Cheerlis'}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 受賞者一覧 */}
      <EntriesNavBar />

      {/* ↑ 結果発表 */}

      <AboutSection id="about" />
      <section id="history" className="section" style={{ backgroundColor: '#f7f8fa' }}>
        <div className="container">
          <div className="columns is-vcentered  is-variable is-8 is-row-reverse">
            <div className="column is-6">
              <h1 className="title">
                <span className="is-family-secondary">HISTORY</span>
                昨年の様子
              </h1>
              <p className="is-size-5 is-size-6-mobile">
                昨年の「MISS CIRCLE CONTEST 2018」は、
                <br />
                けやき坂46、SILENT SIRENらが出演した「AGESTOCK2018 in TOKYO DOME CITY HALL」にて開催されました。
                <br />
                <br />
                "日本一の大学サークル美女"として、札幌大谷大学短期大学部の平館真生さんがグランプリに輝きました。
              </p>
            </div>
            <div className="column is-narrow">
              <picture>
                <source srcSet="/images/last_year@2x.webp" type="image/webp" />
                <img src="/images/last_year@2x.png" width="864" height="480" style={{ width: 864 }} />
              </picture>
            </div>
          </div>
        </div>
      </section>
      <section className="section">
        <div className="container is-slim">
          <h1 className="title has-text-centered">
            <span className="is-family-secondary">VOICE</span>
            歴代受賞者の声
          </h1>
          <div className="columns is-multiline is-margin-top-2">
            <div className="column is-12 is-margin-bottom-1">
              <LegendVoice
                style={{ backgroundColor: '#E6EEF2' }}
                caption={
                  <p className="tag is-primary is-medium is-margin-bottom-1-5 has-text-weight-bold">
                    2017年度 グランプリ
                  </p>
                }
                title={<>自分を成長させる大きなきっかけとなりました</>}
                voice={
                  <>
                    <p className="has-text-weight-semibold">首都大学東京 原口未帆さん</p>
                    <p>
                      ミスサークルコンテスト2017グランプリの原口未帆です！
                      <br />
                      自分に自信がなかった私にとって、ミスコンでの経験は何もかもが挑戦であり、自分を成長させる大きなきっかけとなりました。
                      <br />
                      出場すれば、辛いこともきっとあります。私は毎日のように悩んで泣いての繰り返しでした。
                      <br />
                      でも、その分得たものは比にならない程大きかったです。
                      {/*<br />*/}
                      {/*これは私の大好きな言葉なのですが、「羨むより羨まれろ」です。*/}
                      {/*<br />*/}
                      {/*少しでもミスサークルコンテストに興味を持たれた方は是非とも挑戦してみてください！*/}
                    </p>
                  </>
                }
                src="/images/haraguchi@2x.jpg"
              />
            </div>
            <div className="column is-12 is-margin-bottom-1">
              <LegendVoice
                style={{ backgroundColor: '#E6EEF2' }}
                caption={
                  <p className="tag is-primary is-medium is-margin-bottom-1-5 has-text-weight-bold">
                    2017年度 準グランプリ
                  </p>
                }
                title={<>サークルが大好きな方、人が大好きな方、是非挑戦してみてください！</>}
                voice={
                  <>
                    <p className="has-text-weight-semibold">慶應義塾大学 喜多川あゆさん</p>
                    <p>
                      みなさんこんにちは！ミスサークルコンテスト2017グランプリの喜多川あゆです。
                      <br />
                      私は最後のミス慶應ファイナリストでした。
                      <br />
                      どうにも中途半端な気持ちや報われない気持ちがあり、ミスサークルコンテストへの挑戦を決めました。
                      <br />
                      コンテスト中は辛いと思うこともありました。それでも大好きなサークルのためにも諦めずやりきり、最後舞台で名前を呼ばれた時は達成感や喜び、感謝、感動で震えました。
                      {/*<br />*/}
                      {/*サークルが大好きな方、人が大好きな方、是非挑戦してみてください！きっと楽しいと思います！*/}
                    </p>
                  </>
                }
                src="/images/kitagawa@2x.jpg"
              />
            </div>
            <div className="column is-12">
              <LegendVoice
                style={{ backgroundColor: '#E6EEF2' }}
                caption={
                  <p className="tag is-primary is-medium is-margin-bottom-1-5 has-text-weight-bold">
                    2017年度 準グランプリ
                  </p>
                }
                title={<>少しでもミスコンに興味がある方、ぜひ応募してみてください！</>}
                voice={
                  <>
                    <p className="has-text-weight-semibold">東京理科大学 吉田さくらさん</p>
                    <p>
                      ミスサークルコンテスト2017準グランプリの吉田さくらです！
                      <br />
                      ミスコン活動の上で大変なこともありましたが、その分賞を受賞した時の喜びも一際大きかったです。
                      <br />
                      自分に自信がなくてネガティブでしたが、ミスサークルコンテストを通して少しはポジティブに変われた気がするし、とても良い経験になりました。
                      {/*<br />*/}
                      {/*少しでもミスコンに興味がある方、自分のサークルを有名にしたい方、自分に自信がつけたい方、ぜひ応募してみてください！*/}
                    </p>
                  </>
                }
                src="/images/yoshida@2x.jpg"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="section" style={{ backgroundColor: 'rgb(247, 248, 250)' }}>
        <div className="container is-slim">
          <h1 className="title is-spaced has-text-centered">
            <span className="is-family-secondary">REQUIREMENT</span>
            応募資格
          </h1>
          <h2 className="subtitle has-text-primary has-text-italic has-text-centered has-text-weight-bold">
            全国どこからでもご参加頂けます！
          </h2>
          <div className="notification is-white">
            <div className="content">
              <ul className="is-margin-top-0">
                <li>応募受付対象者：四年制大学・短期大学・大学院・専門学校等、それらに相当する学校に在籍する方。</li>
                <li>
                  学生中心で形成されたサークル、部活、同好会、ゼミ、研究会、及びそのいずれかに準ずるコミュニティに所属していること。
                </li>
              </ul>
            </div>
          </div>

          <div className="columns">
            <div className="column">
              <div className="notification is-white is-fullheight">
                <h1 className="title is-6 is-flex has-text-primary">
                  <span className="icon has-text-primary is-margin-right-0-5">
                    <i className="far fa-check-circle" />
                  </span>
                  スマホ・インターネット利用で参加できる選考
                </h1>
                <p>
                  WEB投票、ツイッターの利用など、インターネット環境があれば、全国どこからでも選考にご参加いただくことが可能です。
                </p>
              </div>
            </div>
            <div className="column">
              <div className="notification is-white is-fullheight">
                <h1 className="title is-6 is-flex has-text-primary">
                  <span className="icon has-text-primary is-margin-right-0-5">
                    <i className="far fa-check-circle" />
                  </span>
                  東京近郊以外在住のファイナリストには、表彰ステージ(東京で開催）への交通費支給あり
                </h1>
                <p>
                  表彰ステージは、例年11月ごろに東京で開催されます。ファイナリストに選ばれた遠方の方には規定に基づいて交通費が支給されます。
                </p>
              </div>
            </div>
            <div className="column">
              <div className="notification is-white is-fullheight">
                <h1 className="title is-6 is-flex has-text-primary">
                  <span className="icon has-text-primary is-margin-right-0-5">
                    <i className="far fa-check-circle" />
                  </span>
                  過去には、関西/九州/四国からのファイナリストも！
                </h1>
                <p>北は北海道から南は沖縄まで、日本全国の大学１年生の方からのご応募をお待ちしています！</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section">
        <div className="container is-slim">
          <h1 className="title is-spaced has-text-centered">
            <span className="is-family-secondary">SCHEDULE</span>
            スケジュール
          </h1>
          <div className="timeline is-centered">
            <header className="timeline-header">
              <span className="tag is-medium has-text-weight-bold">エントリー開始</span>
            </header>
            <div className="timeline-item">
              <div className="timeline-marker" />
              <div className="timeline-content is-size-7 has-text-grey-light">
                <p className="heading">~ 4月30日</p>
                <p className="has-text-weight-bold">
                  1次エントリー
                  <br className="is-hidden-tablet" />
                  締切
                </p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-marker" />
              <div className="timeline-content is-size-7 has-text-grey-light">
                <p className="heading">5月10日12:00 ~ 5月17日11:59</p>
                <p className="has-text-weight-bold">
                  Aブロック2次審査
                  <br className="is-hidden-tablet" />
                  (1次エントリー)
                </p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-marker" />
              <div className="timeline-content is-size-7 has-text-grey-light">
                <p className="heading">~ 5月26日</p>
                <p className="has-text-weight-bold">
                  2次エントリー
                  <br className="is-hidden-tablet" />
                  締切
                </p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-marker" />
              <div className="timeline-content is-size-7 has-text-grey-light">
                <p className="heading">5月30日12:00〜6月6日11:59</p>
                <p className="has-text-weight-bold">
                  Bブロック2次審査
                  <br className="is-hidden-tablet" />
                  (2次エントリー)
                </p>
              </div>
            </div>
            <header className="timeline-header">
              <span className="tag has-text-weight-bold has-text-grey-light">3次審査</span>
            </header>
            <div className="timeline-item">
              <div className="timeline-marker" />
              <div className="timeline-content has-text-grey-light">
                <p className="heading">8月3日12:00〜8月12日21:59</p>
                <p className="has-text-weight-bold is-margin-bottom-0-5">
                  <a
                    className="has-text-grey-light has-text-underline"
                    href="https://www.showroom-live.com/event/mscircle19_kc19aw"
                    target="_blank"
                  >
                    SHOWROOM審査
                  </a>
                </p>
                <p className="heading">8月3日12:00〜8月20日21:59</p>
                <p className="has-text-weight-bold">WEB審査</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-marker" />
              <div className="timeline-content has-text-grey-light">
                <p className="heading">8月13日20:00〜8/20日21:59</p>
                <p className="has-text-weight-bold">mysta審査</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-marker" />
              <div className="timeline-content has-text-grey-light">
                <p className="heading">8月23日</p>
                <p className="has-text-weight-bold">
                  3次審査通過者
                  <br className="is-hidden-tablet" />
                  発表
                </p>
              </div>
            </div>
            <header className="timeline-header">
              <span className="tag has-text-weight-bold has-text-grey-light">4次審査</span>
            </header>
            <div className="timeline-item">
              <div className="timeline-marker" />
              <div className="timeline-content has-text-grey-light">
                <p className="heading">9月4日12:00〜9月29日21:59</p>
                <p className="has-text-weight-bold">WEB審査</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-marker" />
              <div className="timeline-content has-text-grey-light">
                <p className="heading">9月4日12:00〜9月6日21:59</p>
                <p className="has-text-weight-bold is-margin-bottom-0-5">
                  <a
                    className="has-text-grey-light has-text-underline"
                    href="https://www.showroom-live.com/event/ray19_mscircle_yosen"
                    target="_blank"
                  >
                    SHOWROOM審査 予選
                  </a>
                </p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-marker" />
              <div className="timeline-content has-text-grey-light">
                <p className="heading">9月13日12:00〜9月15日21:59</p>
                <p className="has-text-weight-bold is-margin-bottom-0-5">
                  <a className="has-text-grey-light has-text-underline">SHOWROOM審査 準決勝</a>
                </p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-marker" />
              <div className="timeline-content has-text-grey-light">
                <p className="heading">9月16日20:00〜9月29日21:59</p>
                <p className="has-text-weight-bold is-margin-bottom-0-5">
                  <a className="has-text-grey-light has-text-underline">mysta審査</a>
                </p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-marker" />
              <div className="timeline-content has-text-grey-light">
                <p className="heading">9月20日12:00〜9月29日21:59</p>
                <p className="has-text-weight-bold is-margin-bottom-0-5">
                  <a className="has-text-grey-light has-text-underline">SHOWROOM審査 決勝</a>
                </p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-marker" />
              <div className="timeline-content has-text-grey-light">
                <p className="heading">10月3日</p>
                <p className="has-text-weight-bold">
                  4次審査通過者
                  <br className="is-hidden-tablet" />
                  発表
                </p>
              </div>
            </div>
            <header className="timeline-header">
              <span className="tag has-text-weight-bold has-text-grey-light">セミファイナル審査</span>
            </header>
            <div className="timeline-item">
              <div className="timeline-marker" />
              <div className="timeline-content has-text-grey-light">
                <p className="heading">10月7日12:00〜10月20日21:59</p>
                <p className="has-text-weight-bold is-margin-bottom-0-5">
                  <a className="has-text-grey-light" href="/semifinal">
                    WEB審査
                  </a>
                </p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-marker" />
              <div className="timeline-content has-text-grey-light">
                <p className="heading">10月11日20:00〜10月20日21:59</p>
                <p className="has-text-weight-bold is-margin-bottom-0-5">
                  <a
                    className="has-text-grey-light has-text-underline"
                    href="https://www.mysta.tv/blog/2019/10/02/miss-circle-contest-201910/"
                  >
                    mysta審査
                  </a>
                </p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-marker" />
              <div className="timeline-content has-text-grey-light">
                <p className="heading">10月16日11:00～10月20日23:59</p>
                <p className="has-text-weight-bold is-margin-bottom-0-5">
                  <a className="has-text-grey-light has-text-underline" href="/news/2019-10-15">
                    特別協賛審査
                  </a>
                </p>
              </div>
            </div>
            <header className="timeline-header">
              <span className="tag is-primary has-text-weight-bold">ファイナル審査</span>
            </header>
            <div className="timeline-item is-primary">
              <div className="timeline-marker is-primary" />
              <div className="timeline-content">
                <p className="heading">10月29日19:00〜11月10日21:59</p>
                <p className="has-text-weight-bold is-margin-bottom-0-5">
                  <a className="has-text-black-ter">WEB審査</a>
                </p>
              </div>
            </div>
            <div className="timeline-item is-primary">
              <div className="timeline-marker is-primary" />
              <div className="timeline-content">
                <p className="heading">11月2日20:00〜11月10日21:59</p>
                <p className="has-text-weight-bold is-margin-bottom-0-5">
                  <a
                    className="has-text-black-ter has-text-underline"
                    href="https://www.showroom-live.com/event/mscircle19_final"
                  >
                    SHOWROOM審査
                  </a>
                </p>
              </div>
            </div>
            <div className="timeline-item is-primary">
              <div className="timeline-marker is-primary" />
              <div className="timeline-content">
                <p className="heading">11月4日20:00〜11月10日21:59</p>
                <p className="has-text-weight-bold is-margin-bottom-0-5">
                  <a
                    className="has-text-black-ter has-text-underline"
                    href="https://appweb.mysta.tv/web/share/challenge/?challenge_id=2213&creative=2019-1104-1658"
                  >
                    mysta審査
                  </a>
                </p>
              </div>
            </div>
            <div className="timeline-item is-primary">
              <div className="timeline-marker is-primary" />
              <div className="timeline-content">
                <p className="heading">10月29日19:00〜11月10日21:59</p>
                <p className="has-text-weight-bold is-margin-bottom-0-5">
                  <a className="has-text-black-ter has-text-underline" href="/news/2019-10-29">
                    特別協賛審査
                  </a>
                </p>
              </div>
            </div>
            <header className="timeline-header">
              <a
                href="/news/2019-10-04"
                className="tag button is-medium is-primary has-text-weight-bold is-flex-direction-column"
                style={{ height: 60 }}
              >
                <span className="is-size-7">2019年11月16日(土)</span>
                <span className="has-text-underline">表彰式</span>
              </a>
            </header>
          </div>
        </div>
      </section>
      <section className="section" style={{ backgroundColor: 'rgba(242, 97, 97, 0.1)' }}>
        <div className="container is-slim">
          <h1 className="title is-spaced has-text-centered">
            <span className="is-family-secondary has-text-link">姉妹コンテスト</span>
            <img src="/images/logo_frecam.svg" width="300" />
          </h1>
          <div className="columns is-centered">
            <div className="column is-narrow">
              <div className="card is-rounded" style={{ maxWidth: 520, margin: '0 auto' }}>
                <div className="card-image">
                  <figure className="image">
                    <img src="/images/banner@2x.jpg" width="520" height="273" />
                  </figure>
                </div>
                <div className="card-content">
                  <div className="media">
                    <div className="media-content">
                      <p className="title is-4 has-text-link">日本一の新入生を決めるミスコンテスト</p>
                      <p className="subtitle is-6 has-text-link">2019年度入学の新1年生大募集！</p>
                    </div>
                  </div>

                  <div className="content">2019年度入学の新一年生であれば全国どこからでも応募可能！</div>
                </div>
                <footer className="card-footer">
                  <div className="card-footer-item">
                    <a
                      className="button is-medium is-fullwidth is-link has-text-weight-bold"
                      href="https://2019.frecam.jp/?utm_source=misscircle&utm_medium=banner"
                      target="_blank"
                      rel="noopener"
                    >
                      <span>特設サイトを見る</span>
                    </a>
                  </div>
                </footer>
              </div>
            </div>
          </div>
        </div>
      </section>
      <NewsSection id="news">
        <NewsItem
          isNew
          title={
            <a className="has-text-primary has-text-underline" href="#award">
              グランプリが決定しました。
            </a>
          }
          time="2019-11-16"
        />
        <NewsItem
          isNew
          title={
            <a className="has-text-primary has-text-underline" href="/news/2019-11-11-faq">
              表彰式について、注意事項・よくある質問を掲載しました。
            </a>
          }
          time="2019-11-11"
        />
        <NewsItem
          isNew
          title={
            <a className="has-text-primary has-text-underline" href="/news/2019-11-11">
              スペシャルプレゼンターとして昨年度グランプリ「平館真生」さんの出演が決定致しました。
            </a>
          }
          time="2019-11-11"
        />
        <NewsItem
          isNew
          title={
            <a className="has-text-primary has-text-underline" href="/news/2019-10-29">
              「ファイナル 特別協賛審査」リゼクリニック・メンズリゼ様とのコラボ企画「リゼウォーク賞」結果発表。
            </a>
          }
          time="2019-11-11"
        />
        <NewsItem
          title={
            <a
              className="has-text-primary has-text-underline"
              href="https://www.rizeclinic.com/missmrcampus2019/misscircle-vote"
              target="_blank"
            >
              ファイナル WEB投票サイトがオープンしました
            </a>
          }
          time="2019-10-29"
        />
        <NewsItem
          title={
            <a className="has-text-primary has-text-underline" href="/news/2019-10-29">
              ファイナル 特別協賛審査の詳細が決定しました。
            </a>
          }
          time="2019-10-29"
        />
        <NewsItem
          title={
            <a className="has-text-primary has-text-underline" href="/news/2019-10-15">
              「特別協賛審査」リゼクリニック・メンズリゼ様とのコラボ企画第1弾「＃リゼクリニックの日」結果発表。
            </a>
          }
          time="2019-10-23"
        />
        <NewsItem
          title={
            <a className="has-text-primary has-text-underline" href="/final">
              セミファイナル審査通過者を発表しました。
            </a>
          }
          time="2019-10-23"
        />
        <NewsItem
          title={
            <a className="has-text-primary has-text-underline" href="/news/2019-10-15">
              セミファイナル期間「特別協賛審査」として特別協賛の医療脱毛専門の「リゼクリニック・メンズリゼ」様とのコラボ企画が決定しました。
            </a>
          }
          time="2019-10-15"
        />
        <NewsItem
          title={
            <a className="has-text-primary has-text-underline" href="/semifinal">
              セミファイナル審査がスタートしました。
            </a>
          }
          time="2019-10-07"
        />
        <NewsItem
          title={
            <a className="has-text-primary has-text-underline" href="/news/2019-10-04">
              「MISS CIRCLE CONTEST 2019 supported by リゼクリニック ・メンズリゼ」表彰式の開催が決定しました。
            </a>
          }
          time="2019-10-04"
        />
        <NewsItem
          title={
            <a className="has-text-primary has-text-underline" href="/semifinal">
              4次審査通過者を発表しました。
            </a>
          }
          time="2019-10-03"
        />
        <NewsItem title="リゼクリニック様が特別協賛社に決定しました" time="2019-10-03" />
        <NewsItem
          title={
            <a className="has-text-primary has-text-underline" href="/news/2019-09-08-kobecollection">
              9/8(日) 神戸コレクション 2019 AUTUMN/WINTER -ガールズフェスティバル-「SHOWROOM
              SPECIALSTAGE」にて、モデルとしてフレキャン候補者が登場しました。
            </a>
          }
          time="2019-09-08"
        />
        <NewsItem
          title={
            <a className="has-text-primary has-text-underline" href="/third">
              4次審査がスタートしました。
            </a>
          }
          time="2019-09-04"
        />
        <NewsItem
          title={
            <a className="has-text-primary has-text-underline" href="/third">
              3次審査通過者を発表しました。
            </a>
          }
          time="2019-08-23"
        />
        <NewsItem
          title={
            <a className="has-text-primary has-text-underline" href="/second">
              3次審査が終了しました。
            </a>
          }
          time="2019-08-20"
        />
        <NewsItem
          title={
            <a className="has-text-primary has-text-underline" href="/news/2019-08-07-tvasahi">
              8/7（水）MISS/MR COLLECTION 2019 in テレ朝夏祭りに候補者が参加しました
            </a>
          }
          time="2019-08-07"
        />
        <NewsItem
          title={
            <a className="has-text-primary has-text-underline" href="/second">
              3次審査がスタートしました。
            </a>
          }
          time="2019-08-03"
        />

        <NewsItem
          title={
            <a className="has-text-primary has-text-underline" href="https://www.kobe-collection.com/" target="_blank">
              KOBE COLLECTION「SHOWROOM SPECIALSTAGE」 とのタイアップが決定しました！
            </a>
          }
          time="2019-07-16"
        />
        <NewsItem
          title={
            <a className="has-text-primary has-text-underline" href="/second/b">
              Bブロック二次審査通過者を発表しました。
            </a>
          }
          time="2019-06-11"
        />
        <NewsItem
          title={
            <a className="has-text-primary has-text-underline" href="https://mdpr.jp/news/1841287" target="_blank">
              5/30 Bブロック出場者をモデルプレスにて発表しました。
            </a>
          }
          time="2019-05-30"
        />
        <NewsItem
          title={
            <a className="has-text-primary has-text-underline" href="/first/b">
              Bブロック二次審査 WEB投票がスタートしました。
            </a>
          }
          time="2019-05-30"
        />
        <NewsItem
          title={
            <a className="has-text-primary has-text-underline" href="/second/a">
              Aブロック二次審査通過者を発表しました。
            </a>
          }
          time="2019-05-23"
        />
        <NewsItem
          title={
            <a className="has-text-primary has-text-underline" href="https://mdpr.jp/news/1837852" target="_blank">
              5/10 Aブロック出場者をモデルプレスにて発表しました。
            </a>
          }
          time="2019-05-10"
        />
        <NewsItem title="Aブロック二次審査 WEB投票が終了しました。" time="2019-05-17" />
        <NewsItem title="Aブロック二次審査 WEB投票がスタートしました。" time="2019-05-10" />
        <NewsItem title="2次エントリーがスタートしました。" time="2019-05-01" />
        <NewsItem
          title={
            <a
              className="has-text-primary has-text-underline"
              href="https://mdpr.jp/news/detail/1834282"
              target="_blank"
            >
              モデルプレスにてコンテスト情報が掲載されました。
            </a>
          }
          time="2019-04-19"
        />
        <NewsItem title="「モデルプレス」が特別協力に決定しました。" time="2019-04-18" />
        <NewsItem title="MISS CIRCLE CONTEST 2019 公式サイトを公開致しました。" time="2019-03-26" />
      </NewsSection>
    </>
  );
}

export default IndexApp;
